import styled from 'styled-components';
import PricingPlansSelect from './PricingPlansSelect';

const PricingPlansSelectStyled = styled(PricingPlansSelect)`
  ${props => props.theme.input.select};
`;

export default PricingPlansSelectStyled;
